import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { local as localStorage } from '@sorare/core/src/lib/storage';

const SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000;
export const getAfterOnboardingTargetKey = (sport: Sport) => {
  return `leagues_${sport}_afterOnboardingTarget`;
};

export const setAfterOnboardingTarget = (sport: Sport, value: string) => {
  const KEY = getAfterOnboardingTargetKey(sport);

  const data = {
    value,
    ttl: Date.now() + SEVEN_DAYS_IN_MS,
  };

  return localStorage.setItem(KEY, JSON.stringify(data));
};

export const getAfterOnboardingTarget = (sport: Sport) => {
  const KEY = getAfterOnboardingTargetKey(sport);

  try {
    const rawData = localStorage.getItem(KEY);
    if (!rawData) return null;
    const data = JSON.parse(rawData);
    if (Date.now() > data.ttl) {
      return null;
    }
    return data.value;
  } catch (e) {
    return null;
  }
};

export const removeAfterOnboardingTarget = (sport: Sport) => {
  const KEY = getAfterOnboardingTargetKey(sport);
  localStorage.removeItem(KEY);
};
